(() => {
  if (window.__scCartPackageLoaded) return;
  window.__scCartPackageLoaded = true;

  const SELECTORS = {
    packageControl: '[data-sc-package-quantity]',
    packageInput: '[data-sc-package-input]',
    remove: '[data-sc-package-remove]',
    minus: '[data-sc-package-minus]',
    plus: '[data-sc-package-plus]'
  };

  const parseLines = (raw) => {
    try {
      const parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      console.warn('[Spectacle cart] Unable to parse package lines', error);
      return [];
    }
  };

  const setBusy = (element, busy) => {
    const packageCard = element.closest('[data-sc-cart-package]');
    if (packageCard) packageCard.classList.toggle('is-updating', Boolean(busy));
    document.documentElement.classList.toggle('sc-cart-is-updating', Boolean(busy));
  };

  const refreshCart = (cart) => {
    if (window.halo && typeof window.halo.updateCart === 'function') {
      window.halo.updateCart(cart);
      return;
    }
    window.location.reload();
  };

  const updateLines = async (source, lines, quantity) => {
    if (!lines.length) return;
    const safeQuantity = Math.max(0, Number.isFinite(quantity) ? quantity : 0);
    const updates = {};
    lines.forEach((line) => { updates[line] = safeQuantity; });

    setBusy(source, true);
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      const cart = await response.json();
      refreshCart(cart);
    } catch (error) {
      console.error('[Spectacle cart] Package update failed', error);
      window.location.reload();
    } finally {
      setBusy(source, false);
    }
  };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest(SELECTORS.minus);
    const plus = event.target.closest(SELECTORS.plus);
    const remove = event.target.closest(SELECTORS.remove);

    if (!minus && !plus && !remove) return;

    const control = event.target.closest(SELECTORS.packageControl) || remove;
    const lines = parseLines((control && control.getAttribute('data-lines')) || (remove && remove.getAttribute('data-lines')));

    if (!lines.length) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (remove) {
      updateLines(remove, lines, 0);
      return;
    }

    const input = control.querySelector(SELECTORS.packageInput);
    const current = parseInt(input && input.value, 10) || 0;
    const next = plus ? current + 1 : Math.max(0, current - 1);
    if (input) input.value = next;
    updateLines(control, lines, next);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest(SELECTORS.packageInput);
    if (!input) return;

    const control = input.closest(SELECTORS.packageControl);
    const lines = parseLines(control && control.getAttribute('data-lines'));
    if (!lines.length) return;

    event.preventDefault();
    event.stopPropagation();
    const next = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = next;
    updateLines(control, lines, next);
  }, true);
})();
